import { Brand } from '../../components/Brand.tsx';
import { useI18n } from '../../i18n/index.tsx';

/**
 * The introduction video, on a page anybody can open.
 *
 * Public and outside every guard, because it is meant to be pasted into a
 * message and opened by somebody who has not signed in and may not yet have
 * been invited. Nothing here reads the API: it is a heading and a file.
 *
 * The video and its poster live in `frontend/public`, so they keep the names
 * they were given and are served straight off disk by the same process as the
 * app. That also means they are *not* content-hashed — replacing the video
 * with a different cut under the same name will leave some people watching the
 * old one until their cache expires, so a new cut should get a new filename.
 */

const VIDEO = '/leadership-accelerator-intro.mp4';
const POSTER = '/leadership-accelerator-intro.jpg';

export const IntroPage = () => {
  const { t } = useI18n();

  return (
    <div className="mx-auto flex min-h-full max-w-3xl flex-col px-5 pb-16">
      <Brand />

      <main className="flex-1 py-6">
        <p className="font-mono text-[10px] tracking-[0.13em] text-teal uppercase">
          {t('intro.kicker')}
        </p>
        <h1 className="mt-2 text-[30px] leading-[1.08] font-extrabold tracking-[-0.025em]">
          {t('intro.title')}
        </h1>
        <p className="mt-3 max-w-[54ch] text-base text-soft">{t('intro.lead')}</p>

        {/* 16:9, capped rather than full-bleed: it is a screen recording of
            slides, and stretched past its own resolution it only gets softer. */}
        <video
          controls
          playsInline
          preload="metadata"
          poster={POSTER}
          className="mt-6 aspect-video w-full rounded-2xl border border-line bg-ink shadow-card"
        >
          <source src={VIDEO} type="video/mp4" />
          {/* Reached only by a browser that cannot play it at all. */}
          <a href={VIDEO}>{t('intro.fallback')}</a>
        </video>

        <p className="mt-4 text-[13px] text-faint">{t('intro.duration')}</p>
      </main>
    </div>
  );
};
